"use strict"

window.SITE.lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];

function getLang(array) {
	const lang = window.SITE.lang || 'en';
	return array?.[lang] ?? array?.en ?? '';
}

// Пример запуска: showAlertSuccess({pos: 'top center', autoclose:2000})
function showAlertSuccess({
    title = getLang({
        ru: 'Сообщение отправлено',
        en: 'Message sent successfully',
    }),
    body = getLang({
        ru: 'Мы свяжемся с Вами в ближайшее время',
        en: 'We will contact you shortly.',
    }),
    className = 'alert-success',
    pos = 'top center',
    icon = '<span class="material-symbols-rounded icon">check_circle</span>',
    backdrop = false,
    hasClose = true,
    autoclose = false
} = {}) {
    DD.log('showAlertSuccess', title, body);

    new placeHTML({
        type: 'alert',
        placeIn: 'stack',
        stackPosition: pos,
        title: title,
        body: body,
        icon: icon,
        backdrop: backdrop,
        class: className,
        hasClose: hasClose,
        autoClose: autoclose
    });
}


function showAlertError({
    title = getLang({
        ru: 'Произошла ошибка',
        en: 'An error occurred',
    }),
    body = getLang({
        ru: 'Ваше сообщение не отправлено. Пожалуйста, свяжитесь с нами любым удобным способом.',
        en: 'Your message could not be sent. Please contact us using any convenient method.',
    }),
    className = 'alert-danger',
    pos = 'top center',
    icon = '<span class="material-symbols-rounded icon">error</span>',
    backdrop = false,
    hasClose = true,
    autoclose = false
} = {}) {
    DD.log('showAlertError', title, body);

    new placeHTML({
        type: 'alert',
        placeIn: 'stack',
        stackPosition: pos,
        title: title,
        body: body,
        icon: icon,
        backdrop: backdrop,
        class: className,
        hasClose: hasClose,
        autoClose: autoclose
    });
}

function formHandlerDefault($formSelector) {
	const formEl = document.querySelector($formSelector)
	if (!formEl) console.error(`ERR formHandlerDefault: форма:${$formSelector} не найдена`)

	// if (window.SITE.TPLA.length) {
	// 	loadResources(window.SITE.TPLA + "/js/imask.min.js")
	// 		.then(() => {
	// 			const phoneEl = formEl.querySelector('input[type="tel"]')
	// 			IMask(phoneEl, {
	// 				mask: '+{375} (00) 000-00-00'
	// 			})
	// 		})
	// }

	new fsubmit({
		form: formEl,
		onSuccess: () => {
			showAlertSuccess()
			openModal = bootstrap.Modal.getInstance(document.querySelector('.modal.show')); if (openModal) openModal.hide();
		},
		onError: (error) => {
			showAlertError()
		},
	})
}


// обработка agree-privacy
function formAgreePrivacyHandler($formSelector, $checkFormValidity = true) {
	const formEl = document.querySelector($formSelector)
	const checkTerms = formEl.querySelector('.form-agree-privacy')
	const submitBtn = formEl.querySelector('.btn_submit')

	if(!checkTerms || !submitBtn) console.error(`ERR formAgreePrivacyHandler: форма:${$formSelector} не найдена`)

	const submitBtnHandlerEvent = () => {
		const isAgreeTerms = checkTerms.checked;
		const isFormValid = $checkFormValidity ? formEl.checkValidity() : true;
		const isButtonEnabled = isAgreeTerms && isFormValid;
		DD.log(isAgreeTerms, isFormValid, isButtonEnabled)

		submitBtn.disabled = !isButtonEnabled
		submitBtn.classList.toggle('disabled', !isButtonEnabled)
	}
	formEl.addEventListener('input', submitBtnHandlerEvent)
	formEl.addEventListener('change', submitBtnHandlerEvent)
	formEl.dispatchEvent(new CustomEvent('input'))
}


(function (){
	if (window.SITE.TPLA.length) {
		const items = document.querySelectorAll('[data-fancybox]')
		if (items.length) {
			items.forEach(item => { item.dataset.fancyboxReady = 'true' })

			loadResources([
				window.SITE.TPLA + '/js/fancybox.umd.js',
				window.SITE.TPLA + '/css/fancybox.min.css',
			]).then(() => {
				DD.log('fancybox-ready')
				Fancybox.bind("[data-fancybox]")
			}).catch((e) => console.error(e))
		}
	}
})()


// Анимация как https://codepen.io/kjbrum/pen/wBBLXx на кнопке "Position Aware"
document.querySelectorAll('.btn').forEach(btn => {
  const setPosition = event => {
    const rect = btn.getBoundingClientRect()

    btn.style.setProperty('--btn-hover-x', `${event.clientX - rect.left}px`)
    btn.style.setProperty('--btn-hover-y', `${event.clientY - rect.top}px`)
  }

  btn.addEventListener('mouseenter', setPosition)
  btn.addEventListener('mouseleave', setPosition)
})


window.addEventListener('load', () => { 
	setTimeout(() => {
		AOS.init({once: true});
	}, 100)
});
